import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'

const ControlledPrintersCell = ({ printers }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleShow = (e) => {
    e.stopPropagation()
    setIsOpen(!isOpen)
  }
  const printerNameWithComma = (printer, isLast) =>
    `${printer.name}${isLast ? '' : ','}`

  const renderPrinterItems = () => {
    if (printers.length === 1) {
      return (
        <span className="controlled-printers-cell__item">
          {printers[0].name}
        </span>
      )
    } else if (isOpen && printers.length > 1) {
      return (
        <>
          <ul className="controlled-printers-cell__list">
            {map(printers, (printer, index) => (
              <li className="controlled-printers-cell__item" key={printer.uuid}>
                {printerNameWithComma(printer, index === printers.length - 1)}
              </li>
            ))}
          </ul>
          <button
            className="controlled-printers-cell__button"
            onClick={handleShow}
          >
            show less
          </button>
        </>
      )
    } else if (!isOpen && printers.length > 1) {
      return (
        <>
          <ul className="controlled-printers-cell__list">
            <li
              className="controlled-printers-cell__item"
              key={printers[0].uuid}
            >
              {printers[0].name}
            </li>
            ...
          </ul>
          <button
            className="controlled-printers-cell__button"
            onClick={handleShow}
          >
            show more
          </button>
        </>
      )
    }
  }

  return (
    <>
      <div className="controlled-printers-cell">{renderPrinterItems()}</div>
      <ul className="controlled-printers-cell-mobile">
        {map(printers, (printer) => (
          <li
            className="controlled-printers-cell-mobile__item"
            key={printer.uuid}
          >
            {printer.name}
          </li>
        ))}
      </ul>
    </>
  )
}

ControlledPrintersCell.propTypes = {
  printers: PropTypes.array,
}

export default ControlledPrintersCell
